import _toConsumableArray from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.regexp.match.js";
import "core-js/modules/es6.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import EntityPicker from 'src/components/Pickers/Picker';
import { dialog } from 'src/boot/mixins.js';
import SubscriptionTypeUpgrade from 'src/components/SubscriptionTypeUpgrade';
import User from 'src/store/models/User';
import { each } from 'lodash';
export default {
  mixins: [dialog],
  components: {
    EntityPicker: EntityPicker,
    TeDialog: TeDialog,
    SubscriptionTypeUpgrade: SubscriptionTypeUpgrade
  },
  props: {
    projectId: {
      type: Number,
      default: null
    },
    groupId: {
      type: Number,
      default: null
    },
    onInvite: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    },
    showEntityColumn: {
      type: Boolean,
      default: true
    },
    provider: {
      type: String,
      default: ''
    },
    importedUsers: {
      type: Array,
      default: function _default() {
        return [];
      },
      validator: function validator(value) {
        return value.every(function (user) {
          return user.email && user.mode && user.id;
        });
      }
    }
  },
  data: function data() {
    return {
      step: 'invite-users',
      loading: false,
      users: [this.getUserRowTemplate(), this.getUserRowTemplate(), this.getUserRowTemplate()],
      addToOptions: [{
        label: this.$tc('general.project', 1),
        value: 'project'
      }, {
        label: this.$tc('general.group', 1),
        value: 'group'
      }]
    };
  },
  computed: {
    allSelected: {
      get: function get() {
        return !this.users.filter(function (user) {
          return !user.selected;
        }).length;
      },
      set: function set(val) {
        return this.users.forEach(function (user) {
          user.selected = val;
        });
      }
    },
    errorUsers: function errorUsers() {
      return this.users.filter(function (user) {
        return user.error;
      });
    },
    validUsers: function validUsers() {
      return this.users.filter(function (user) {
        return user.email;
      });
    },
    selectedUsers: function selectedUsers() {
      return this.users.filter(function (user) {
        return user.selected;
      });
    },
    licensesLeft: function licensesLeft() {
      return this.me.account.subscription_limit_users - this.me.account.active_users_count - this.validUsers.length;
    },
    showModeColumn: function showModeColumn() {
      return !this.isMobile && this.users.filter(function (user) {
        return user.mode !== 'manual';
      }).length;
    }
  },
  methods: {
    addNewUser: function addNewUser() {
      this.users.push(this.getUserRowTemplate());
    },
    openInviteUsersFromIntegrationDialog: function openInviteUsersFromIntegrationDialog(provider) {
      this.openDialog('InviteUsersFromIntegration', {
        provider: provider,
        onComplete: this.addUsers,
        excludedUsers: this.users.map(function (user) {
          return user.email;
        })
      });
    },
    inviteUsers: function inviteUsers() {
      var _this = this;

      this.loading = true;
      this.showLoading();
      User.$inviteUsers(this.users.filter(function (user) {
        return user.email;
      })).then(function (response) {
        User.insertOrUpdate({
          data: response.data
        });
        _this.loading = false;

        _this.hideLoading();

        _this.$root.$emit('refresh-users');

        if (_this.onInvite) {
          _this.onInvite(response.data);
        }

        _this.$q.notify({
          color: 'positive',
          textColor: 'white',
          message: _this.$t('components.dialogs.users_invited')
        });

        _this.step = 'invite-completed';
        _this.users = [];

        if (process.env.GOOGLE_ANALYTICS_ENABLED) {
          window.ueuq = window.uetq || [];
          window.ueuq.push('event', 'user_invite', {}); // HUBSPOT

          window._hsq.push(['setPath', 'users/invite']);

          window._hsq.push(['trackPageView']);

          if (_this.$gtag) {
            _this.$gtag.event('user_invite', process.env.GOOGLE_ANALYTICS_DEBUGMODE ? {
              debug_mode: true
            } : {});
          }
        }
      }).catch(function (error) {
        console.error('inviteuserserror', error);
        var response = error.response;

        if (response.data.errors) {
          var errorList = response.data.errors;
          each(errorList, function (error, key) {
            _this.users = _this.validUsers;

            var user = _this.users.find(function (user) {
              return user.email === key;
            });

            if (!user) {
              var userIndex = key.match(/users\.(.*[0-9])\.email/);

              if (userIndex && userIndex.length) {
                user = _this.users[userIndex[1]];
              }
            }

            if (user) {
              user.error = true;
              user.errorMessage = Array.isArray(error) && error.length ? error[0] : error;
            }

            _this.$forceUpdate();
          });
        }
      }).finally(function () {
        _this.loading = false;

        _this.hideLoading();
      });
    },
    addUsers: function addUsers() {
      var _this2 = this;

      var users = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var provider = arguments.length > 1 ? arguments[1] : undefined;
      users.forEach(function (user) {
        var myUser = _this2.users.find(function (myUser) {
          return myUser.email === user.email || !myUser.email && !myUser.name;
        });

        if (myUser) {
          myUser.mode = provider;
          myUser.name = user.name;
          myUser.email = user.email;
          myUser.id = user.id;
        } else {
          _this2.users.push(_this2.getUserRowTemplate(user, provider));
        }
      });
    },
    eventsMap: function eventsMap(itemEvents) {
      delete itemEvents.click;
      return itemEvents;
    },
    updateUserAccessLevel: function updateUserAccessLevel(user, accessLevel) {
      if (!this.me.account.hasFeatureAccess('access_levels')) {
        this.$refs["access-level-".concat(accessLevel)][0].showTooltip();
        return;
      }

      user.workspace_access_level = accessLevel;
    },
    openAccessLevelPickerDialog: function openAccessLevelPickerDialog() {
      if (!this.me.account.hasFeatureAccess('access_levels')) {
        this.$refs.upgradeAccessLevels.showTooltip();
        return;
      }

      this.openDialog('PickerDialog', {
        entityType: 'access level',
        options: this.visibleRolesOptions,
        search: false,
        onComplete: this.onAddAccessLevel
      });
    },
    onAddAccessLevel: function onAddAccessLevel(accessLevel) {
      this.selectedUsers.forEach(function (user) {
        user.workspace_access_level = accessLevel.value;
      });
    },
    onAddGroup: function onAddGroup(group) {
      this.selectedUsers.forEach(function (user) {
        user.add_to = 'group';
        user.group_id = group.group_id;
      });
    },
    onAddProjects: function onAddProjects(projects) {
      this.selectedUsers.forEach(function (user) {
        user.add_to = 'project';
        user.project_ids = projects.map(function (project) {
          return project.project_id;
        });
      });
    },
    removeSelected: function removeSelected() {
      this.users = this.users.filter(function (user) {
        return !user.selected;
      });

      if (!this.users.length) {
        this.users.push(this.getUserRowTemplate());
      }
    },
    removeUser: function removeUser(user, index) {
      this.users.splice(index, 1);
    },
    getUserRowTemplate: function getUserRowTemplate() {
      var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var provider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'manual';
      return {
        selected: false,
        mode: provider,
        id: user ? user.id : null,
        error: false,
        email: user ? user.email : null,
        name: user ? user.name : null,
        workspace_access_level: !User.me().account.hasFeatureAccess('access_levels') ? 'owner' : 'member',
        add_to: this.groupId ? 'group' : 'project',
        group_id: this.groupId ? this.groupId : null,
        project_ids: this.projectId ? [this.projectId] : []
      };
    }
  },
  mounted: function mounted() {
    if (this.importedUsers.length) {
      this.users = _toConsumableArray(this.importedUsers);
    }
  }
};